import { render, staticRenderFns } from "./VasionDateTimeField.vue?vue&type=template&id=0a19e3fd&scoped=true&"
import script from "./VasionDateTimeField.vue?vue&type=script&lang=js&"
export * from "./VasionDateTimeField.vue?vue&type=script&lang=js&"
import style0 from "./VasionDateTimeField.vue?vue&type=style&index=0&id=0a19e3fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a19e3fd",
  null
  
)

export default component.exports